import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import PropTypes from 'prop-types';

import { Button } from '@material-ui/core';
import { useStyles } from './styles';

function SuperModalBase(
  { title, description, onClose, onOpen, onConfirm, styles },
  ref
) {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(open);
  }, [open]);

  const handleOpen = () => {
    setOpen(true);

    if (onOpen) {
      onOpen();
    }
  };

  const handleClose = () => {
    setOpen(false);

    if (onClose) {
      onClose();
    }
  };

  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    }

    handleClose();
  };

  const handleToggle = () => {
    setOpen((currentOpen) => !currentOpen);
  };

  useImperativeHandle(ref, () => ({
    open: handleOpen,
    close: handleClose,
    toggle: handleToggle,
  }));

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={open}>
        <div className={classes.paper} style={styles}>
          {title && <h2 id="simple-modal-title">{title}</h2>}
          {description && <p id="simple-modal-description">{description}</p>}
          <div>
            <Button variant="contained" color="primary" onClick={handleConfirm}>
              Prosseguir
            </Button>
            <Button onClick={handleClose}>Sair</Button>
          </div>
        </div>
      </Fade>
    </Modal>
  );
}

const SuperModal = forwardRef(SuperModalBase);

SuperModal.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  onClose: PropTypes.func,
  onOpen: PropTypes.func,
  onConfirm: PropTypes.func,
};

SuperModal.displayName = 'SuperModal';

export default SuperModal;
